<template>
   <v-app>
    <header>
      <b-navbar toggleable="lg" type="light" class="bg-primary2 main-nav animated shadow-lg slideInDown" fixed="top" >
        <b-container>
          <b-navbar-brand @click="$router.push('/')">
            <Logo></Logo>
          </b-navbar-brand>
            <button class="btn btn-md  btn-light text-primary-2 " @click="cerrarSesion()" v-if="isMobile && loginStatus">
              <i class="fas fa-sign-out-alt"></i>
            </button>
            <b-collapse id="nav-text-collapse" is-nav v-if="loginStatus">
              <b-navbar-nav class="m-lg-auto">
            
              </b-navbar-nav>
              <b-navbar-nav right>
                <b-nav-item>
                  <button class="btn btn-md my-2  btn-light text-primary-2 ml-2" >
                    <i class="mdi mdi-account mdi-18px " ></i> 
                    <template v-if="user.perfiles[0].perfil.id == 3">Gerente:</template>
                    <template v-if="user.perfiles[0].perfil.id == 7">Ejecutivo:</template>
                    <template v-if="user.perfiles[0].perfil.id == 12">Coordinador:</template>
                    <template v-if="user.perfiles[0].perfil.id == 2">Subdirector:</template>
                    <template v-if="user.perfiles[0].perfil.id == 10  ">Trade Marketing: </template>
                    <template v-if="user.perfiles[0].perfil.id == 6  ">Embajador:</template>
                     {{user.nombre}} 
                    <template v-if="user.perfiles[0].perfil.id == 3 || user.perfiles[0].perfil.id == 7">  IDPDV: {{user.id_pdv}}   </template>
                  
                  </button>
                  <!-- <button class="btn btn-md my-2 my-sm-0 btn-light text-primary-2 ml-2" @click="cerrarSesion()"> -->
                    <span @click="cerrarSesion()" class="ml-5" style="color:#fff;"><i class="mdi mdi-close"></i> Cerrar sesión</span>
                  <!-- </button> -->
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
        </b-container>
      </b-navbar>
      <!-- <NavbarPF v-if="loggin == 1" :usuario="usuario"></NavbarPF> -->
    </header>
    <v-main :style="isMobile ? 'z-index: 24; margin-top:40px;' : 'z-index: 24; margin-top:50px;'">       
        <router-view />
    </v-main>
   </v-app>
</template>

<script>
import Logo from './components/Logo.vue';
import Cookies from "js-cookie";
export default {
  components: { Logo },
  name: 'App',
  data(){
    return{
      isMobile: this.$mobile()
    }
  },
  computed: {
    loginStatus() {
      return this.$store.getters.getLoginStatus
    },
    user() {
      return this.$store.getters.getInfoUser;
    },
  },
  methods:{
    cerrarSesion(){
        this.$store.commit(
            "setLoginStatus",
            false
        );
        this.$store.commit(
            "setInfoUser",
            null
        );    
        Cookies.remove("session_id");
        location.reload();
    },
  }
};
</script>
<style scoped>
.bg-primary2{
  background: #039CF3;
}
</style>